import { checkingAccessToTheEntity, checkPermissions, featureAccess } from '@/utils/accesses'

const getters = {
  userRole: (state) => state.userData.role || null,
  isAdmin: (state) =>
    featureAccess('PM_FALLBACK')
      ? checkPermissions(state?.userData?.permissions, ['admin_legacy'])
      : state.userData.role === 'admin',

  isSales: state => {
    if (!featureAccess('PM_FALLBACK')) {
      return state.userData.role === 'sales-manager'
    }

    const permissions = state?.userData?.permissions
    return checkPermissions(permissions, ['sales_manager_legacy'])
  },

  isOrgAdmin: state => {
    if (!featureAccess('PM_FALLBACK')) {
      return state.userData.role === 'organization-admin'
    }

    const permissions = state?.userData?.permissions
    return checkPermissions(permissions, [
      'user_access_organization',
      'api_key_organization',
    ])
  },
  isOrgCustomer: (state, getters) => {
    if (!featureAccess('PM_FALLBACK')) {
      return state.userData.role === 'customer'
    }
    return (
      checkPermissions(state?.userData?.permissions, ['customer_legacy']) &&
      !getters.isOrgAdmin
    )
  },

  isExternalSystem: (state) =>
    featureAccess('PM_FALLBACK') &&
    checkPermissions(state?.userData?.permissions, ['external_system_legacy']),
    getCurrentFiat: (state) => state.userData.preferredCurrency,
    hasEntityAccess: (state) => checkingAccessToTheEntity(state.userData.permissions || []),
    permissions: (state) => state.userData && state.userData.permissions,
    currentUserPermissions: (state) => state.userData && state.userData.permissions || [],
    hasRestrictNegativeFlag: (state) => {
      const { permissions, requestsLeft } = state.userData
      return (
        requestsLeft !== null &&
        requestsLeft <= 0 &&
        checkPermissions(permissions, ['billing_restrict_negative'])
      )
    }
}

export default getters
